export default "__VITE_ASSET__DJbOxOTh__"